import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { GetTopicRequest, GetTopicResponse } from 'src/app/models/topic';
import { CallableFunction } from 'src/app/resources/app-firebase';

@Injectable({
  providedIn: 'root'
})
export class TopicService {
  constructor(private aff: AngularFireFunctions) {}

  getTopic(request: GetTopicRequest): Observable<GetTopicResponse> {
    const callable = this.aff.httpsCallable(CallableFunction.GET_TOPIC);
    return callable(request);
  }
}
